export default {
  loading: {
    id: 'payment_methods_list_loading',
    defaultMessage: 'Loading...',
  },
}
